/**
 * Vue route name for catalog product vs provider (supplier) product detail.
 * Opens provider product when the SKU has a provider or is not owned by the
 * active entity (customer app only). Operator logistics UI only registers
 * the catalog product route (`/products/:id/`), so operators always use it.
 *
 * @param {Object|null|undefined} product
 * @param {number|string|undefined|null} currentEntityId
 * @param {string|undefined} [entityProfile] `session.current_entity_profile` (`operator` | `customer` | …)
 * @returns {'product'|'providerproduct'}
 */
export function productDetailRouteName(product, currentEntityId, entityProfile) {
    if (!product || product.id == null) {
        return "product";
    }
    if (entityProfile === "operator") {
        return "product";
    }
    if (product.provider || product.owner != currentEntityId) {
        return "providerproduct";
    }
    return "product";
}
